<template>
    <logo class="logo--light">
        <slot />
    </logo>
</template>

<script>
import Logo from "@/components/publish/styles/headers/logo.vue";

export default {
    props: {},
    components: {
        Logo,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.logo {
    width: 168px;
    height: 32px;
}
</style>
